/**
 * @module Lens
 */
import permutation2 from '../permutation/permutation-2.js';
/**
 * Gets the value inside a nested `source` object by provided `path`
 * written in dot-notation.
 */
export default function get(...args) {
    // @ts-ignore
    return permutation2((sourceOrPath, pathOrSource) => {
        let source, path;
        if (typeof sourceOrPath === 'string') {
            source = pathOrSource;
            path = sourceOrPath;
        }
        else {
            source = sourceOrPath;
            path = pathOrSource;
        }
        const keys = path.split('.');
        const length = keys.length;
        let result = source;
        for (let index = 0; index < length; index += 1) {
            result = result?.[keys?.[index]];
        }
        return result;
    })(...args);
}
